import React from 'react';
import { FaLinkedinIn, FaPaperPlane, FaInstagram } from 'react-icons/fa';
import './Footer.css';

// 1. Import your PDF documents from the assets folder
import privacyPolicyPdf from '../assets/Privacy-Policy.pdf';
import termsOfServicePdf from '../assets/Terms-of-Service.pdf';
import documentationPdf from '../assets/Documentation.pdf';
import supportPdf from '../assets/Support.pdf';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        {/* Column 1: Brand Info */}
        <div className="footer-column footer-brand">
          <a href="/" className="footer-logo">DEPLOY - <span>X</span></a>
          <p>Empowering seamless deployment with modern solutions. Scalable, Reliable, Secure.</p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/projects">Projects</a></li>
            <li><a href="/careers">Careers</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Column 3: Resources */}
        <div className="footer-column footer-links">
          <h4>Resources</h4>
          <ul>
            {/* 2. Update href attributes to use the imported PDFs */}
            <li><a href={privacyPolicyPdf} target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
            <li><a href={termsOfServicePdf} target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
            <li><a href={documentationPdf} target="_blank" rel="noopener noreferrer">Documentation</a></li>
            <li><a href={supportPdf} target="_blank" rel="noopener noreferrer">Support</a></li>
          </ul>
        </div>

        {/* Column 4: Newsletter & Socials */}
        <div className="footer-column footer-subscribe">
          <h4>Stay Updated</h4>
          <p>Get the latest news and updates from DEPLOY-X.</p>
          <form className="subscribe-form">
            <input type="email" placeholder="Enter your email" required />
            <button type="submit" aria-label="Subscribe">
              <FaPaperPlane />
            </button>
          </form>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/company/deploy-x-in" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="https://www.instagram.com/deploy.x_?igsh=MXVobHRjMDdtbXMzbg==" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} DEPLOY-X. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;